import React from 'react';

interface KannadaTaglineProps {
  className?: string;
  imgClassName?: string;
}

const KannadaTagline: React.FC<KannadaTaglineProps> = ({
  className = '',
  imgClassName = 'h-10 w-auto',
}) => {
  return (
    <span
      className={`inline-flex items-center pointer-events-none select-none ${className}`.trim()}
      role="img"
      aria-label="ಕನ್ನಡಿಗರೊಂದಿಗೆ ಕನ್ನಡದಲ್ಲಿ"
    >
      <img
        src="/images/kannada-tagline.png"
        alt=""
        className={`block object-contain ${imgClassName}`.trim()}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
    </span>
  );
};

export default KannadaTagline;
